module.exports = __webpack_public_path__ + "media/icons/close-black-dfc7d7ce.svg";